import { HttpClient } from 'HttpClient/HttpClient';
import { AxiosRequestConfig } from 'axios';
import { inject } from 'aurelia-dependency-injection';
import { AuthenticationStore } from 'Stores';
import { ApiService } from './ApiService';
import { AzureAdAuthenticationService } from './AzureAdAuthenticationService';

@inject(HttpClient, AuthenticationStore, AzureAdAuthenticationService)
export class AuthenticationService extends ApiService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly authenticationStore: AuthenticationStore,
        private readonly azureAdAuthenticationService: AzureAdAuthenticationService
    ) {
        super();
    }

    public refreshTokenPromise: any;
    public runSignInPromise: any;

    public installInterceptors(): void {
        this.httpClient.addRequestInterceptor((requestConfig: AxiosRequestConfig) =>
            this.onBeforeRequest(requestConfig)
        );
    }

    public async refreshAccessToken(refreshToken: string): Promise<void> {
        await this.azureAdAuthenticationService.refreshToken(refreshToken);
    }

    public async refreshAccessTokenIfNeeded(): Promise<void> {
        //Retrieve refresh token from store.
        const refreshToken = this.authenticationStore.refreshToken;
        const tokenExpiration = this.authenticationStore.expiresIn;

        // No token currently set.
        if (!refreshToken || !tokenExpiration) {
            return;
        }

        if (Math.round(Date.now() / 1000) > tokenExpiration) {
            if (!this.refreshTokenPromise) {
                this.refreshTokenPromise = this.refreshAccessToken(refreshToken);
            }
            await this.refreshTokenPromise;
            this.refreshTokenPromise = null;
        }
    }

    public async onBeforeRequest(requestConfig: AxiosRequestConfig): Promise<AxiosRequestConfig> {
        if (requestConfig.url !== '/auth-config') {
            await this.refreshAccessTokenIfNeeded();
            // Retrieve access token from store.
            const accessToken = this.authenticationStore.accessToken;
            if (!accessToken && !this.runSignInPromise) {
                this.runSignInPromise = this.azureAdAuthenticationService.runSignInFlow();
                await this.runSignInPromise;
            }
            // Add Authorization header in request
            requestConfig.headers.Authorization = `bearer ${accessToken}`;
        }
        return requestConfig;
    }
}
